import styled, {
  css,
  CSSProperties,
  DefaultTheme,
} from 'styled-components/macro';
import { StackGap, StackSpacing } from './stack.types';

const getGapValue = (value?: CSSProperties['gap']) =>
  typeof value === 'number' ? `${value}px` : value || '0';

const resolveGap = (gap: StackGap) => {
  if (typeof gap === 'object') {
    const rowGap = getGapValue(gap.row);
    const columnGap = getGapValue(gap.column);

    return `
        row-gap: ${rowGap};
        column-gap: ${columnGap};
      `;
  }

  return `gap: ${getGapValue(gap)};`;
};

const resolveSpacing = (theme: DefaultTheme, spacing: StackSpacing) => {
  if (typeof spacing === 'object') {
    const row = spacing.row ? theme.spacings[spacing.row] : '0';
    const column = spacing.column ? theme.spacings[spacing.column] : '0';

    return css`
      row-gap: ${row};
      column-gap: ${column};
    `;
  }

  return css`
    gap: ${theme.spacings[spacing]};
  `;
};

type StackProps = {
  height?: CSSProperties['height'];
  width?: CSSProperties['width'];
  flex?: CSSProperties['flex'];
  padding?: CSSProperties['padding'];
  direction?: CSSProperties['flexDirection'];
  align?: CSSProperties['alignItems'];
  justify?: CSSProperties['justifyContent'];
  wrap?: CSSProperties['flexWrap'];

  /** @deprecated Используй spacing */
  gap?: StackGap;
  spacing?: StackSpacing;
  center?: boolean;
};

const Stack = styled.div<StackProps>`
  ${({
    theme,
    padding = '0px',
    width,
    height = 'auto',
    flex = 'initial',
    direction = 'row',
    align = 'stretch',
    justify = 'flex-start',
    wrap = 'nowrap',
    gap = '16px',
    spacing,
    center,
  }) => css`
    position: relative;
    display: flex;
    height: ${typeof height === 'number' ? height + 'px' : height};
    width: ${typeof width === 'number' ? width + 'px' : width};
    flex: ${flex};
    flex-direction: ${direction};
    align-items: ${align};
    justify-content: ${justify};
    flex-wrap: ${wrap};
    padding: ${typeof padding === 'number' ? padding + 'px' : padding};

    /*
    Gap пока что deprecated,
    поэтому после удаления gap оставить только
    ${spacing && resolveSpacing(theme, spacing)}
    */
    ${spacing ? resolveSpacing(theme, spacing) : gap ? resolveGap(gap) : null}

    ${center &&
    css`
      height: 100%;
      align-items: center;
      justify-content: center;
    `};
  `}
`;

export const VStack = styled(Stack)`
  flex-direction: column;
`;

export const HStack = styled(Stack)`
  flex-direction: row;
`;

VStack.displayName = 'VStack';
HStack.displayName = 'HStack';
